<div class="row cfa-nowrap-row cfa-button" [class.disabled]="loading">
    <div class="col-auto pr-0 pl-0">
        <div class="row cfa-nowrap-row justify-content-center">
            <div class="col-auto pr-0 pl-0">
                <svg-icon src="{{getIconUrl()}}" class="cfa-icon"></svg-icon>

                <div class="cfa-cart-badge" [class.pulse]="newCartBadgeNumber" *ngIf="showCartBadge && (cartBadgeNumber > 0 || loading)">
                    <div [cfaLoading]="loading" class="cfa-cart-badge-container">
                        <div class="cfa-cart-badge-number">
                            {{cartBadgeNumber > 0 ? (cartBadgeNumber > 99 ? '99+' : cartBadgeNumber) : '-' }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row cfa-nowrap-row justify-content-center" *ngIf="showCartTotal">
            <div class="col-auto cfa-11 cfa-cart-total pr-0 pl-0 mt-1">
                <span>$</span>{{cartTotal.toFixed(2)}}
            </div>
        </div>
    </div>
</div>
